import Page from "./Page";

export default class Overlay {
	constructor (container) {

		this.container = container;

		this.overlay = document.getElementById('overlay');
		this.overlayWrap = document.getElementById('overlay_wrap');
		this.btnCloseModal = document.getElementById('btn_close_modal');

		this.nextSibling = null;
		this.previousSibling = null;

		this.bindEvents();

	}


	bindEvents () {

		this.container.addEventListener('click', event => {

			if ( event.target.nodeName !== 'A' )
			{
				return;
			}

			event.preventDefault();




			if ( event.target.getAttribute('data-type') === 'video' )
			{
				let imgUrl = event.target.getAttribute('href');
				this.overlayWrap.innerHTML = '<div class="video_wrap"><iframe width="560" height="315" src="' + imgUrl + '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>';
				// this.overlayWrap.innerHTML = '<div class="video_wrap"><video id="video_player" src="' + imgUrl + '" controls playsinline autoplay></video></div>';
				//const player = new Plyr('#video_player');
				Page.addClass(this.overlayWrap, 'video');
			}
			else
			{
				this.openImage( event.target );
			}

			Page.addClass(this.overlay, 'is-visible');
		});

		this.btnCloseModal.addEventListener('click', event => {
			Page.removeClass(this.overlay, 'is-visible');
			Page.removeClass(this.overlayWrap, 'video');
			this.overlayWrap.innerHTML = '';
		});

		this.overlay.addEventListener('click', event => {
			if ( event.target.nodeName !== 'BUTTON' )
			{
				return;
			}

			if ( Page.hasClass(event.target, 'prev') )
			{
				this.openImage( this.previousSibling );
			}
			else if ( Page.hasClass(event.target, 'next') )
			{
				this.openImage( this.nextSibling );
			}
			else
			{
				return;
			}

			console.log('next / prev!');

		});

	}

	openImage ( el )
	{
		let imgUrl = el.getAttribute('href');
		let img = el.querySelector('img');

		Page.addClass(this.overlay, 'is-loading');

		// find next
		this.nextSibling = this.getSibling(el, true);

		// find prev
		this.previousSibling = this.getSibling(el, false);

		let overlayHTML = '<img src="' + img.getAttribute('src') + '" alt="" />'
			+ '<p>' + img.getAttribute('alt') + '</p>'
			+ '<div class="arrow_nav">'
			+ ( (this.previousSibling) ? '<button class="prev" />' : '' )
			+ ( (this.nextSibling) ? '<button class="next" />' : '' )
			+ '</div>';


		this.overlayWrap.innerHTML = overlayHTML;

		let newImg = new Image();
		newImg.onload = () => {
			let loadImg = this.overlayWrap.querySelector('img');
			loadImg.setAttribute('src', imgUrl);
			Page.removeClass(this.overlay, 'is-loading');
		};
		newImg.src = imgUrl;
	}

	getSibling ( el, getNext )
	{
		let sibling =  (getNext) ? el.nextElementSibling : el.previousElementSibling;

		if ( sibling && sibling.nodeName === 'DIV' && Page.hasClass( sibling, 'group_br' ) )
		{
			sibling = (getNext) ? sibling.nextElementSibling : sibling.previousElementSibling;
		}
		if ( sibling && sibling.nodeName !== 'A' )
		{
			sibling = null;
		}
		return sibling;
	}

}